<template>
  <div class="pa-0">
    <v-row>
      <v-col cols="12">
        <div class="setting-item mb-3">
          <v-switch
            v-model="settings.confirm_delivery"
            :label="$t('automatic_delivery_no_confirm_company')"
            inset
            color="primary"
            hide-details
          />
        </div>

        <div class="setting-item mb-3">
          <v-switch
            v-model="settings.can_see_report"
            :label="$t('can_see_report')"
            inset
            color="primary"
            hide-details
          />
        </div>

        <div class="setting-item mb-3">
          <v-switch
            v-model="settings.can_see_ordered"
            :label="$t('can_see_ordered')"
            inset
            color="primary"
            hide-details
          />
        </div>

        <div class="setting-item mb-3">
          <v-switch
            v-model="settings.all_cooperation"
            :label="$t('allow_meal_to_partner')"
            inset
            color="primary"
            hide-details
          />
        </div>

        <div class="setting-item mb-3">
          <v-switch
            v-model="settings.worker"
            :label="$t('enable_meal_pickup_another_branch')"
            inset
            color="primary"
            hide-details
          />
        </div>

        <div class="setting-item mb-3">
          <v-checkbox
            v-model="settings.show_price"
            :label="$t('view_price_order_meal')"
            @click="$emit('change-show-price')"
            color="primary"
            hide-details
          />
        </div>
      </v-col>
    </v-row>

    <!-- Table Distance Settings -->
    <div v-show="companyType === 'table'" class="mt-4">
      <div class="setting-item">
        <text-field
          v-model="settings.table_distance"
          :label="$t('distance_between_tables')"
          type="number"
          outlined
          dense
          hide-details
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicSettingsTab",
  props: {
    settings: {
      type: Object,
      required: true,
    },
    companyType: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.setting-item {
  min-height: 48px;
  display: flex;
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
}
</style>
